module.exports = __webpack_public_path__ + "static/media/ithraPrimary.3f4a773d.svg";